export const Country = [
    { value: '', label: 'Choose one' },
    { value: 'Choice 1', label: 'IT' },
    { value: 'Choice 2', label: 'Language' },
    { value: 'Choice 3', label: 'Science' },
    { value: 'Choice 4', label: 'Health' },
    { value: 'Choice 5', label: 'Humanities' },
    { value: 'Choice 6', label: 'Business' },
    { value: 'Choice 7', label: 'Maths' },
    { value: 'Choice 8', label: 'Marketing' },
    { value: 'UM', label: 'United States of America' },
    { value: 'AF', label: 'Afghanistan' },
    { value: 'AL', label: 'Albania' },
    { value: 'AD', label: 'Andorra' },
    { value: 'AG', label: 'Antigua and Barbuda' },
    { value: 'AU', label: 'Australia' },
    { value: 'AM', label: 'Armenia' },
    { value: 'AO', label: 'Angola' },
    { value: 'AR', label: 'Argentina' },
    { value: 'AT', label: 'Austria' },
    { value: 'AZ', label: 'Azerbaijan' },
    { value: 'BA', label: 'Bosnia and Herzegovina' },
    { value: 'BB', label: 'Barbados' },
    { value: 'BD', label: 'Bangladesh' },
    { value: 'BE', label: 'Belgium' },
    { value: 'BF', label: 'Burkina Faso' },
    { value: 'BG', label: 'Bulgaria' },
    { value: 'BH', label: 'Bahrain' },
    { value: 'BJ', label: 'Benin' },
    { value: 'BN', label: 'Brunei' },
    { value: 'BO', label: 'Bolivia' },
    { value: 'BT', label: 'Bhutan' },
    { value: 'BY', label: 'Belarus' },
    { value: 'CD', label: 'Congo' },
    { value: 'CA', label: 'Canada' },
    { value: 'CF', label: 'Central African Republic' },
    { value: 'CI', label: 'Cote d\'Ivoire' },
    { value: 'CL', label: 'Chile' },
    { value: 'CM', label: 'Cameroon' },
    { value: 'CN', label: 'China' },
    { value: 'CO', label: 'Colombia' },
    { value: 'CU', label: 'Cuba' },
    { value: 'CV', label: 'Cabo Verde' },
    { value: 'CY', label: 'Cyprus' },
    { value: 'DJ', label: 'Djibouti' },
    { value: 'DK', label: 'Denmark' },
    { value: 'DM', label: 'Dominica' },
    { value: 'DO', label: 'Dominican Republic' },
    { value: 'EC', label: 'Ecuador' },
    { value: 'EE', label: 'Estonia' },
    { value: 'ER', label: 'Eritrea' },
    { value: 'ET', label: 'Ethiopia' },
    { value: 'FI', label: 'Finland' },
    { value: 'FJ', label: 'Fiji' },
    { value: 'FR', label: 'France' },
    { value: 'GA', label: 'Gabon' },
    { value: 'GD', label: 'Grenada' },
    { value: 'GE', label: 'Georgia' },
    { value: 'GH', label: 'Ghana' },
    { value: 'HN', label: 'Honduras' },
    { value: 'HT', label: 'Haiti' },
    { value: 'HU', label: 'Hungary' },
    { value: 'ID', label: 'Indonesia' },
    { value: 'IE', label: 'Ireland' },
    { value: 'IL', label: 'Israel' },
    { value: 'IN', label: 'India' },
    { value: 'IQ', label: 'Iraq' },
    { value: 'IR', label: 'Iran' },
    { value: 'IS', label: 'Iceland' },
    { value: 'IT', label: 'Italy' },
    { value: 'JM', label: 'Jamaica' },
    { value: 'JO', label: 'Jordan' },
    { value: 'JP', label: 'Japan' },
    { value: 'KE', label: 'Kenya' },
    { value: 'KG', label: 'Kyrgyzstan' },
    { value: 'KI', label: 'Kiribati' },
    { value: 'KW', label: 'Kuwait' },
    { value: 'KZ', label: 'Kazakhstan' },
    { value: 'LA', label: 'Laos' },
    { value: 'LB', label: 'Lebanon' },
    { value: 'LI', label: 'Liechtenstein' },
    { value: 'LR', label: 'Liberia' },
    { value: 'LS', label: 'Lesotho' },
    { value: 'LT', label: 'Lithuania' },
    { value: 'LU', label: 'Luxembourg' },
    { value: 'LV', label: 'Latvia' },
    { value: 'LY', label: 'Libya' },
    { value: 'MA', label: 'Morocco' },
    { value: 'MC', label: 'Monaco' },
    { value: 'MD', label: 'Moldova' },
    { value: 'ME', label: 'Montenegro' },
    { value: 'MG', label: 'Madagascar' },
    { value: 'MH', label: 'Marshall Islands' },
    { value: 'MK', label: 'Macedonia (FYROM)' },
    { value: 'ML', label: 'Mali' },
    { value: 'MM', label: 'Myanmar (formerly Burma)' },
    { value: 'MN', label: 'Mongolia' },
    { value: 'MR', label: 'Mauritania' },
    { value: 'MT', label: 'Malta' },
    { value: 'MV', label: 'Maldives' },
    { value: 'MW', label: 'Malawi' },
    { value: 'MX', label: 'Mexico' },
    { value: 'MZ', label: 'Mozambique' },
    { value: 'NA', label: 'Namibia' },
    { value: 'NG', label: 'Nigeria' },
    { value: 'NO', label: 'Norway' },
    { value: 'NP', label: 'Nepal' },
    { value: 'NR', label: 'Nauru' },
    { value: 'NZ', label: 'New Zealand' },
    { value: 'OM', label: 'Oman' },
    { value: 'PA', label: 'Panama' },
    { value: 'PF', label: 'Paraguay' },
    { value: 'PG', label: 'Papua New Guinea' },
    { value: 'PH', label: 'Philippines' },
    { value: 'PK', label: 'Pakistan' },
    { value: 'PL', label: 'Poland' },
    { value: 'QA', label: 'Qatar' },
    { value: 'RO', label: 'Romania' },
    { value: 'RU', label: 'Russia' },
    { value: 'RW', label: 'Rwanda' },
    { value: 'SA', label: 'Saudi Arabia' },
    { value: 'SB', label: 'Solomon Islands' },
    { value: 'SC', label: 'Seychelles' },
    { value: 'SD', label: 'Sudan' },
    { value: 'SE', label: 'Sweden' },
    { value: 'SG', label: 'Singapore' },
    { value: 'TG', label: 'Togo' },
    { value: 'TH', label: 'Thailand' },
    { value: 'TJ', label: 'Tajikistan' },
    { value: 'TL', label: 'Timor-Leste' },
    { value: 'TM', label: 'Turkmenistan' },
    { value: 'TN', label: 'Tunisia' },
    { value: 'TO', label: 'Tonga' },
    { value: 'TR', label: 'Turkey' },
    { value: 'TT', label: 'Trinidad and Tobago' },
    { value: 'TW', label: 'Taiwan' },
    { value: 'UA', label: 'Ukraine' },
    { value: 'UG', label: 'Uganda' },
    { value: 'UY', label: 'Uruguay' },
    { value: 'UZ', label: 'Uzbekistan' },
    { value: 'VA', label: 'Vatican City (Holy See)' },
    { value: 'VE', label: 'Venezuela' },
    { value: 'VN', label: 'Vietnam' },
    { value: 'VU', label: 'Vanuatu' },
    { value: 'YE', label: 'Yemen' },
    { value: 'ZM', label: 'Zambia' },
    { value: 'ZW', label: 'Zimbabwe' },
]

export const Expirationdata = [
    { value: '', label: 'Choose one' },
    { value: 'Alabama', label: 'Alabama' },
    { value: 'Alaska', label: 'Alaska' },
    { value: 'American Samoa', label: 'American Samoa' },
    { value: 'Arkansas', label: 'Arkansas' },
    { value: 'California', label: 'California' },
    { value: 'Colorado', label: 'Colorado' },
    { value: 'Connecticut', label: 'Connecticut' },
    { value: 'Delaware', label: 'Delaware' },
    { value: 'Florida', label: 'Florida' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Idaho', label: 'Idaho' }
]
export const Quantity = [
    { value: '', label: '1' },
    { value: 'Choice 1', label: '2' },
    { value: 'Choice 2', label: '3' },
    { value: 'Choice 3', label: '4' }
]